var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g(_vm._b({ref:"dropdown",staticClass:"vs-con-dropdown_x parent-dropdown",attrs:{"type":"button"}},'button',_vm.$attrs,false),_vm.listeners),[_vm._t("default",null,{"visible":_vm.vsDropdownVisible})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }